import React, {useEffect} from 'react';
import {generateAIVideosText} from '../generateAIVideosText';
import {
  BACKGROUND_MUSIC_OPTIONS,
  VIDEO_LENGTH_OPTIONS,
} from '../../../../data/models/AI/VideoGenerationOptions';
import ToggleSwitch from '../../../../uiToolkit/Inputs/ToggleSwitch';
import YesNoOption from '../../../../uiToolkit/Inputs/YesNoOption';
import Dropdown from '../../../../uiToolkit/Inputs/Dropdown';

interface Props {
  videoDuration?: string;
  setVideoDuration: (value: string) => void;
  enableBackgroundMusic: boolean;
  setEnableBackgroundMusic: (value: boolean) => void;
  backgroundMusicType?: string;
  setBackgroundMusicType: (value: string) => void;
}

const VideoDuratonStep = React.memo(
  ({
    setVideoDuration,
    videoDuration,
    enableBackgroundMusic,
    setEnableBackgroundMusic,
    backgroundMusicType,
    setBackgroundMusicType,
  }: Props) => {
    useEffect(() => {
      if (
        enableBackgroundMusic &&
        !backgroundMusicType &&
        BACKGROUND_MUSIC_OPTIONS.length > 0
      ) {
        setBackgroundMusicType(BACKGROUND_MUSIC_OPTIONS[0].key);
      }
    }, [enableBackgroundMusic, backgroundMusicType, setBackgroundMusicType]);

    return (
      <div className="StepContainer">
        <h5 className="StepTitle">{generateAIVideosText.videoSettingsTitle}</h5>
        <h5 className="SectionTitle mt-4">
          {generateAIVideosText.videoDurationLabel}
        </h5>
        <div className="DurationCheckboxGroup">
          <ToggleSwitch
            options={VIDEO_LENGTH_OPTIONS}
            onChange={setVideoDuration}
            selectedKey={videoDuration}
          />
        </div>
        <h5 className="SectionTitle mt-4">
          {generateAIVideosText.backgroundMusicLabel}
        </h5>
        <YesNoOption
          onSelect={setEnableBackgroundMusic}
          value={enableBackgroundMusic}
          className="OptionsSection"
        />
        {enableBackgroundMusic && (
          <>
            <h5 className="SectionTitle mt-4">
              {generateAIVideosText.backgroundMusicTypeLabel}
            </h5>
            <Dropdown
              options={BACKGROUND_MUSIC_OPTIONS}
              selectedOption={backgroundMusicType}
              setSelectedOption={setBackgroundMusicType}
              className="BackgroundMusicDropdown"
              isMandatory
            />
          </>
        )}
      </div>
    );
  },
);

export default VideoDuratonStep;
